import { ZoomableImage } from "./ZoomableImage";

// KYC document / photo thumbnail that opens an interactive pan/zoom viewer on click.
// Renders private-bucket images via presigned URLs (S3Image, via ZoomableImage).
export function ImageThumb({
  src,
  label,
  h = 120,
}: {
  src?: string | null;
  label?: string;
  h?: number;
}) {
  return (
    <ZoomableImage
      src={src}
      h={h}
      alt={label}
      emptyLabel={label ? `No ${label}` : "No image"}
      title={label}
      caption={label}
    />
  );
}
